import script from "./DataTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableRow.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableRow.vue?vue&type=style&index=0&id=034c5b31&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034c5b31"]])

export default __exports__